// @ts-ignore
 
import request from "src/lib/axios";

/** 分页查询商品类目（扁平） GET /api/v1/product-categories */
export async function ProductCategoryControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductCategoryControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductCategoryDtoArray>(
    "/api/v1/product-categories",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建商品类目 POST /api/v1/product-categories */
export async function ProductCategoryControllerCreateV1(
  body: MyApi.CreateProductCategoryDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductCategoryDto>(
    "/api/v1/product-categories",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 查询商品类目详情 GET /api/v1/product-categories/${param0} */
export async function ProductCategoryControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductCategoryControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductCategoryDto>(
    `/api/v1/product-categories/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新商品类目 PUT /api/v1/product-categories/${param0} */
export async function ProductCategoryControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductCategoryControllerUpdateV1Params,
  body: MyApi.UpdateProductCategoryDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductCategoryDto>(
    `/api/v1/product-categories/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除商品类目（软删除） DELETE /api/v1/product-categories/${param0} */
export async function ProductCategoryControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductCategoryControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/product-categories/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询商品类目树（全量） GET /api/v1/product-categories/tree */
export async function ProductCategoryControllerTreeV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputProductCategoryTreeDtoArray>(
    "/api/v1/product-categories/tree",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
